import vuei18n from '@/plugins/vue-i18n'
import moment from 'moment'
import { sanitizeAmount }  from '@/utils/rcm.general.utils';
import { backgroundColor } from '@/config/rcm'

const getGeneralInformationAccount = selectedAccount => {
  const accountDetail = selectedAccount
  const statusAccount = getStatusName(accountDetail.status)

  const primarySection = [
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.patientName'
      ),
      content: accountDetail.patientName,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.patientId'
      ),
      content: accountDetail.patientId,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.patientDocumentType'
      ),
      content: accountDetail.patientDocumentType,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.patientDocumentNumber'
      ),
      content: accountDetail.patientDocumentNumber,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.eventNumber'
      ),
      content: accountDetail.originEventId,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.eventDate'
      ),
      content: accountDetail.originEventCreationDateTime ? 
        moment(accountDetail.originEventCreationDateTime).format('DD/MM/YYYY HH:mm') : null,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.serviceType'
      ),
      content: accountDetail.serviceTypeName,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    }
  ];

  const secondarySection = [
    {
      header: vuei18n.t('rcm.accountDetail.generalInformation.titlesGeneralInformation.insurer'),
      content: accountDetail.agreementName,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customCols: {
        required: true,
        colsHeader: {
          cols: 'auto'
        },
        colsContent: {
          cols: 10
        }
      },
      customClass: null
    },
    {
      header: vuei18n.t('rcm.accountDetail.generalInformation.titlesGeneralInformation.originInvoiceGroupId'),
      content: accountDetail.originInvoiceGroupId,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null,
      isLink:true,
      url: `/rcm/pre-settlements/${accountDetail.originInvoiceGroupId}`
    },
    {
      header: vuei18n.t('rcm.accountDetail.generalInformation.titlesGeneralInformation.settlementNumber'),
      content: accountDetail.settlementNumber,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t('rcm.accountDetail.generalInformation.titlesGeneralInformation.externalId'),
      content: accountDetail.externalId,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t('rcm.accountDetail.generalInformation.titlesGeneralInformation.authorizationId'),
      content: accountDetail.authorizationId,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t('rcm.accountDetail.generalInformation.titlesGeneralInformation.regime'),
      content: accountDetail.regime || 'N/A',
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.agreementPlanType'
      ),
      content: accountDetail.agreementPlanType,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.invoiceSource'
      ),
      content: accountDetail.invoiceSource,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.invoiceNumber'
      ),
      content: accountDetail.invoiceNumber ||
        vuei18n.t('rcm.accountDetail.generalInformation.defaultInformation.defaultInvoiceAmount'),
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.invoiceDate'
      ),
      content: accountDetail.invoiceDateTime ?
        moment(accountDetail.invoiceDateTime).format('DD/MM/YYYY HH:mm') : null,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.invoiceBranch'
      ),
      content: accountDetail.invoiceOriginProviderBranchName,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.responsible'
      ),
      content: accountDetail.responsibleEmailAddress 
                ? `${accountDetail.responsibleName} (${accountDetail.responsibleEmailAddress})` 
                : null,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t('rcm.accountDetail.generalInformation.titlesGeneralInformation.reassignedInvoiceNumber'),
      content: accountDetail.reassignedInvoiceNumber,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null,
      isLink: true,
      url: `/rcm/account/${accountDetail.reassignedAccountId}`
    }
  ];

  const tertiarySection = [
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.createdAt'
      ),
      content: moment(accountDetail.createdAt).format('DD/MM/YYYY HH:mm'),
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.stateAccount'
      ),
      content: statusAccount,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: getCustomClassByStateAccount(accountDetail.status)
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.agreement'
      ),
      content: accountDetail.agreementCode,
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.healthcarePlanCoverage'
      ),
      content: getHealthCarePlanCoverage(accountDetail),
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    },
    {
      header: vuei18n.t(
        'rcm.accountDetail.generalInformation.titlesGeneralInformation.invoiceAmountTotal'
      ),
      content: sanitizeAmount(accountDetail.invoiceAmount),
      backgroundColor: backgroundColor.principalBackgroundColor,
      customClass: null
    }
  ];

	const voidedStatusDialog = accountDetail?.lastChangeLog?.reasonOfChange
	? {
		body: accountDetail?.lastChangeLog?.reasonOfChange
	}
	: null;
  return {
    primarySection: primarySection,
    secondarySection: secondarySection,
    tertiarySection: tertiarySection,
		voidedStatusDialog
  }
}

const getStatusName = statusAccount => {
  const statusNamesMap = {
    IN_PROGRESS: vuei18n.t('rcm.filtersText.statusAccounts.inProgress'),
    PRE_INVOICED: vuei18n.t('rcm.filtersText.statusAccounts.preInvoiced'),
    INVOICED: vuei18n.t('rcm.filtersText.statusAccounts.invoiced'),
    VOIDED: vuei18n.t('rcm.filtersText.statusAccounts.voided'),
    READY_TO_GENERATE: vuei18n.t('rcm.filtersText.statusAccounts.readyToGenerate'),
    PACKAGE_GENERATED: vuei18n.t('rcm.filtersText.statusAccounts.packageGenerated'),
    PENDING_AUDIT: vuei18n.t('rcm.filtersText.statusAccounts.pendingAudit'),
    ERROR: vuei18n.t('rcm.filtersText.statusAccounts.error'),
    COMPLETE_AUDIT: vuei18n.t('rcm.filtersText.statusAccounts.completeAudit'),
    SENT: vuei18n.t('rcm.filtersText.statusAccounts.sent'),
    SETTLED: vuei18n.t('rcm.filtersText.statusAccounts.settled'),
  }

  return statusNamesMap[statusAccount]
}

const getDefaultStatusName = statusValue => {
  const valueNamesMap = { PENDING: vuei18n.t('rcm.rcmGridItems.defaultStatus.pending') };
  return valueNamesMap[statusValue??'PENDING']??statusValue;
}

const getCustomClassByStateAccount = statusAccount => {
  switch (statusAccount) {
    case 'IN_PROGRESS':
      return 'custom-content-text-progress'
    case 'READY_TO_SETTLE':
    case 'PACKAGE_GENERATED':
    case 'READY_TO_AUDIT':
    case 'IN_INTERNAL_AUDIT':
    case 'IN_EXTERNAL_AUDIT':
    case 'AUDITED':
    case 'VOIDED':
      return null
  }
}

const getHealthCarePlanCoverage = accountDetail => {
  const { healthcarePlanCoverage } = accountDetail;

  if(!healthcarePlanCoverage){
    return vuei18n.t('rcm.accountDetail.generalInformation.defaultInformation.defaultHealthCarePlanCoverage')
  }

  return healthcarePlanCoverage
}

export { getGeneralInformationAccount, getStatusName, getDefaultStatusName }
